import { render, staticRenderFns } from "./TopNavigationBar.vue?vue&type=template&id=745550fb&scoped=true&"
import script from "./TopNavigationBar.vue?vue&type=script&lang=ts&"
export * from "./TopNavigationBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745550fb",
  null
  
)

export default component.exports